const accessReport = {

    REPORT: { path: '/downtime-analysis', name: 'Downtime Analysis' },

    FILTER: { path: '/filter-asset-data', name: 'Filter Asset Data' },

    AUDIT_REPORT: { path: '/audit-report', name: 'Audit Report' },
    AUDIT_REPORT_DETAILS: { path: '/audit-report-details', name: 'Audit Details' },

    ASSET_DEPRECIATION_REPORT: { path: '/asset-depreciation-report', name: 'Asset Depreciation Report' },

    ASSET_AGE_REPORT: { path: '/asset-age-report', name: 'Asset Age Report' },

    ASSET_MOVEMENT_REPORT: { path: '/asset-movement-report', name: 'Asset Movement Report' },

    ASSETS_DUE_DISPOSAL_REPORT: { path: '/assets-due-disposal-report', name: 'Assets Due Disposal Report' },

    WORK_ORDER_SUMMARY_REPORT: { path: '/work-order-summary-report', name: 'Work Order Summary Report' },

    MAINTENANCE_HISTORY_ASSET_REPORT: { path: '/maintenance-history-asset-report', name: 'Maintenance History Asset Report' },

    PLANNED_VS_ACTUAL_REPORT: { path: '/planned-vs-actual-report', name: 'Planned vs Actual Report' },

    OVERDUE_MAINTENANCE_REPORT: { path: '/overdue-maintenance-report', name: 'Overdue Maintenance Report' },

}

export default accessReport;